import { isEmpty, isNil } from 'ramda';

import { TValidator } from './types';

export const ERR_REQUIRED = 'Required';

export const required: TValidator = (value) => {
  if (isEmpty(value)) {
    return ERR_REQUIRED;
  }
  if (isNil(value)) {
    return ERR_REQUIRED;
  }
  // eslint-disable-next-line no-restricted-globals
  if (typeof value === 'number' && isNaN(value)) {
    return ERR_REQUIRED;
  }
  return undefined;
};
